import { render } from "./editMechanicalEmbroideryMaterialCompositionModal.vue?vue&type=template&id=e150f636&scoped=true&ts=true"
import script from "./editMechanicalEmbroideryMaterialCompositionModal.vue?vue&type=script&lang=ts"
export * from "./editMechanicalEmbroideryMaterialCompositionModal.vue?vue&type=script&lang=ts"

import "./editMechanicalEmbroideryMaterialCompositionModal.vue?vue&type=style&index=0&id=e150f636&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e150f636"]])

export default __exports__